export default new class InstagramSlider {
    constructor() {
        this.slider = '.fs-instagram-slider';

        if (!document.querySelector(this.slider)) return;

        this.sliderContainerId = 'slider-container';
        this.accessToken = '3599046662.1677ed0.aa0d8b4cc84443cda3e429c063855ac9';
        this.limitPhotos = '12'
        this.instagramLink = 'https://www.instagram.com/fashiong_shop';

        this.getInstagramData();
    }

    getInstagramData() {
        fetch(`https://api.instagram.com/v1/users/self/media/recent/?access_token=${this.accessToken}&count=${this.limitPhotos}`)
            .then(res => res.json())
            .then(this.handleSuccess)
            .catch(this.handleError)
    }

    handleError = error => {
        const root = document.getElementById(this.sliderContainerId);

        root.innerHTML = `<div class="fs-instagram-error">
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 512 512"><path d="M505.403 406.394L295.389 58.102c-8.274-13.721-23.367-22.245-39.39-22.245s-31.116 8.524-39.391 22.246L6.595 406.394c-8.551 14.182-8.804 31.95-.661 46.37 8.145 14.42 23.491 23.378 40.051 23.378h420.028c16.56 0 31.907-8.958 40.052-23.379 8.143-14.421 7.89-32.189-.662-46.369zm-28.364 29.978a12.684 12.684 0 0 1-11.026 6.436H45.985a12.68 12.68 0 0 1-11.025-6.435 12.683 12.683 0 0 1 .181-12.765L245.156 75.316A12.732 12.732 0 0 1 256 69.192c4.41 0 8.565 2.347 10.843 6.124l210.013 348.292a12.677 12.677 0 0 1 .183 12.764z"/><path d="M256.154 173.005c-12.68 0-22.576 6.804-22.576 18.866 0 36.802 4.329 89.686 4.329 126.489.001 9.587 8.352 13.607 18.248 13.607 7.422 0 17.937-4.02 17.937-13.607 0-36.802 4.329-89.686 4.329-126.489 0-12.061-10.205-18.866-22.267-18.866zM256.465 353.306c-13.607 0-23.814 10.824-23.814 23.814 0 12.68 10.206 23.814 23.814 23.814 12.68 0 23.505-11.134 23.505-23.814 0-12.99-10.826-23.814-23.505-23.814z"/></svg>                
                            <h2>Что то пошло не так :( </h2>
                            <p>Попробуйте перезагрузить страницу, если это не помогло,
                             вы можете перейти по прямой ссылке в <a href="${this.instagramLink}" target="_blank">наш инстаграм</a></p>
                        </div>`
    }

    handleSuccess = json => {
        this.renderContent(json.data);
    }

    renderContent(data) {
        const root = document.getElementById(this.sliderContainerId);

        root.innerHTML = this.renderPosts(data).join('');
        this.initSlider();
    }

    renderPosts(posts) {
        return posts.map(post => {
            return (`
                <div class="fs-instagram-slider--item">
                    ${this.renderPostCover(post)}
                    <img class="fs-instagram-slider--img" src=${post.images.low_resolution.url} alt="" />
                </div>
            `)
        })
    }

    renderPostCover(post) {
        return (`
            <div class="fs-instagram-slider--cover">
                <div class="fs-instagram-slider--cover-top">
                    <span class="fs-instagram-slider--info">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" width="16" height="16" viewBox="0 0 492.719 492.719"><path d="M492.719 166.008c0-73.486-59.573-133.056-133.059-133.056-47.985 0-89.891 25.484-113.302 63.569-23.408-38.085-65.332-63.569-113.316-63.569C59.556 32.952 0 92.522 0 166.008c0 40.009 17.729 75.803 45.671 100.178l188.545 188.553a17.17 17.17 0 0 0 24.284 0l188.545-188.553c27.943-24.375 45.674-60.169 45.674-100.178z"/></svg>
                        ${post.likes.count}
                    </span>
                    <span class="fs-instagram-slider--info">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" width="16" height="16" viewBox="0 0 60 60"><path d="M30 1.5c-16.542 0-30 12.112-30 27 0 5.205 1.647 10.246 4.768 14.604-.591 6.537-2.175 11.39-4.475 13.689a1 1 0 0 0 .847 1.697c.405-.057 9.813-1.412 16.617-5.338C21.622 54.711 25.738 55.5 30 55.5c16.542 0 30-12.112 30-27s-13.458-27-30-27z"/></svg>
                        ${post.comments.count}
                    </span>
                </div>
                <a href=${post.link} target="_blank" class="fs-instagram-slider--link">Перейти к посту</a>
                <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" width="16" height="16" viewBox="0 0 511.626 511.627"><path d="M392.857 292.354h-18.274c-2.669 0-4.859.855-6.563 2.573-1.718 1.708-2.573 3.897-2.573 6.563v91.361c0 12.563-4.47 23.315-13.415 32.262-8.945 8.945-19.701 13.414-32.264 13.414H82.224c-12.562 0-23.317-4.469-32.264-13.414-8.945-8.946-13.417-19.698-13.417-32.262V155.31c0-12.562 4.471-23.313 13.417-32.259 8.947-8.947 19.702-13.418 32.264-13.418h200.994c2.669 0 4.859-.859 6.57-2.57 1.711-1.713 2.566-3.9 2.566-6.567V82.221c0-2.662-.855-4.853-2.566-6.563-1.711-1.713-3.901-2.568-6.57-2.568H82.224c-22.648 0-42.016 8.042-58.102 24.125C8.042 113.297 0 132.665 0 155.313v237.542c0 22.647 8.042 42.018 24.123 58.095 16.086 16.084 35.454 24.13 58.102 24.13h237.543c22.647 0 42.017-8.046 58.101-24.13 16.085-16.077 24.127-35.447 24.127-58.095v-91.358c0-2.669-.856-4.859-2.574-6.57-1.713-1.718-3.903-2.573-6.565-2.573z"/><path d="M506.199 41.971c-3.617-3.617-7.905-5.424-12.85-5.424H347.171c-4.948 0-9.233 1.807-12.847 5.424-3.617 3.615-5.428 7.898-5.428 12.847s1.811 9.233 5.428 12.85l50.247 50.248-186.147 186.151c-1.906 1.903-2.856 4.093-2.856 6.563 0 2.479.953 4.668 2.856 6.571l32.548 32.544c1.903 1.903 4.093 2.852 6.567 2.852s4.665-.948 6.567-2.852l186.148-186.148 50.251 50.248c3.614 3.617 7.898 5.426 12.847 5.426s9.233-1.809 12.851-5.426c3.617-3.616 5.424-7.898 5.424-12.847V54.818c-.001-4.952-1.814-9.232-5.428-12.847z"/></svg>
            </div>
        `)
    }

    initSlider() {
        $(`#${this.sliderContainerId}`).slick({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToScroll: 1,
            accessibility: false,
            variableWidth: true,
            autoplay: true,
            autoplaySpeed: 3000,
        });
    }
}